import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { DeleteClientContactActions } from "store/ducks/settings/client-contact";

export function* deleteClientContactRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.delete,
      `/client-contact/delete/${id}`
    );

    const { data } = responseBody;
    yield put(DeleteClientContactActions.success(data));
    notify("success", "Contato deletado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(DeleteClientContactActions.failure(errorMessage));
  }
}
